import { Component, HostBinding, Input } from '@angular/core';
import { TaxonomyDefinitions } from '../../helpers/datev.excel.helper';

@Component({
    selector: 'aumico-taxonomy-preview',
    template: `<div>Preview {{ taxonomy.rawBalanceTemplate.name }}</div>
        <div class="balancesheet">
            <div>
                <ng-container *ngFor="let item of taxonomy.rawBalanceTemplate.group.sortedItems">
                    <div [ngClass]="'group counter-level-1 level-1'">
                        <span>{{ item.title }}</span>
                        <ng-container
                            *ngTemplateOutlet="recursiveX; context: { $implicit: item.sortedItems, level: 1 }"
                        >
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
        <div>
            <div>
                <h2 class="reset-counter-1 reset-counter-2 reset-counter-3 reset-counter-4">GuV</h2>
                <ng-container *ngFor="let item of taxonomy.rawIncomeTemplate.group.sortedItems">
                    <div [ngClass]="'group counter-level-4 level-4' + (item.isHiddenGroup ? ' hidden' : '')">
                        <span *ngIf="item.type !== undefined">{{ item.caption }}</span>
                        <span *ngIf="item.type == undefined">{{ item.title }}</span>
                        <ng-container
                            *ngTemplateOutlet="recursiveX; context: { $implicit: item.sortedItems, level: 4 }"
                        >
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
        <ng-template #recursiveX let-items let-level="level">
            <ng-container *ngFor="let item of items">
                <ng-container *ngIf="item.type !== undefined; then itemTemplate; else groupTemplate"></ng-container>
                <ng-template #itemTemplate>
                    <ng-container
                        *ngTemplateOutlet="renderItem; context: { $implicit: item, level: level }"
                    ></ng-container>
                </ng-template>
                <ng-template #groupTemplate>
                    <ng-container
                        *ngTemplateOutlet="renderGroup; context: { $implicit: item, level: level }"
                    ></ng-container>
                </ng-template>
            </ng-container>
        </ng-template>
        <ng-template #renderItem let-item let-level="level">
            <div [ngClass]="'item counter-level-' + (level + 1) + ' level-' + (level + 1)">
                <span>{{ item.caption }}</span>
                <div
                    *ngFor="let subItem of item.accounts"
                    [ngClass]="'subItem counter-level-' + (level + 2) + ' level-' + (level + 2)"
                >
                    <span>{{ subItem.caption }}</span>
                </div>
            </div>
        </ng-template>
        <ng-template #renderGroup let-group let-level="level">
            <div
                [ngClass]="
                    'group counter-level-' +
                    (level + 1) +
                    ' level-' +
                    (level + 1) +
                    (group.isHiddenGroup ? ' hidden' : '')
                "
            >
                <span>{{ group.name }}</span>
                <ng-container
                    *ngTemplateOutlet="recursiveX; context: { $implicit: group.sortedItems, level: level + 1 }"
                >
                </ng-container>
            </div>
        </ng-template> `,
    styleUrls: ['taxonomy-preview.component.scss'],
})
export class TaxonomyPreviewComponent {
    @Input() taxonomy: TaxonomyDefinitions;

    @HostBinding('style.--prev-style-1') style1 = 'none';
    @HostBinding('style.--prev-style-2') style2 = 'upper-alpha';
    @HostBinding('style.--prev-style-3') style3 = 'upper-roman';
    @HostBinding('style.--prev-style-4') style4 = 'decimal';
    @HostBinding('style.--prev-style-5') style5 = 'lower-alpha';
}
